import { CloudCommand } from "../types.js";

export const getConnectionsCount: CloudCommand = {
    action: "USER_INFOS/GET_CONNECTIONS_COUNT",
    commandName: "linkedin.user.getConnectionsCount",
    buildPayload: () => ({}),
};
